import LocalKRPC from './KRPC.js'
import LocalARENA from './ARENA.js'
import LocalJPPC from './JPPC.js'

export {
  LocalKRPC,
  LocalARENA,
  LocalJPPC,
}
